"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('@angular/common/http');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var operators_1 = require("rxjs/operators");
var deliverables_shared_service_1 = require("../deliverables-shared.service");
var deliverable_client_config_1 = require("../../deliverable.client.config");
var helpers_1 = require("../../helpers");
var i0 = require("@angular/core");
var i1 = require("@angular/common/http");
var i2 = require("../../deliverable.client.config");
var ProductDefinitionInstanceService = /** @class */ (function () {
    /**
     * Initialises a new instance of the ProductDefinitionInstanceService /> class.
     * @param http
     * @param config
     */
    function ProductDefinitionInstanceService(http, config) {
        this.http = http;
        this.config = config;
    }
    /**
     * Create New Version Async.
     * @param productInstanceId
     * @returns An Observable containing the ProductDefinitionInstance
     */
    ProductDefinitionInstanceService.prototype.CreateNewVersionAsync = function (productInstanceId) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/" + productInstanceId + "/createnewversion", null)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Get.
     * @param id
     * @returns An Observable containing the ProductDefinitionInstance
     */
    ProductDefinitionInstanceService.prototype.GetAsync = function (id) {
        return this.http.get(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/" + id)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List Async.
     * @param page
     * @param pageSize
     * @param versionTypeId
     * @returns An Observable containing the ProductDefinitionInstance
     */
    ProductDefinitionInstanceService.prototype.ListAsync = function (page, pageSize, versionTypeId) {
        if (page === void 0) { page = 1; }
        if (pageSize === void 0) { pageSize = 10; }
        var params = new http_1.HttpParams();
        if (page)
            params = params.set('page', page.toString());
        if (pageSize)
            params = params.set('pageSize', pageSize.toString());
        if (versionTypeId)
            params = params.set('versionTypeId', versionTypeId.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List Current Versions Async.
     * @returns An Observable containing the Array<ProductDefinitionInstanceStub>
     */
    ProductDefinitionInstanceService.prototype.ListCurrentVersionsAsync = function () {
        return this.http.get(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/listcurrentversions")
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List Product Versions Async.
     * @param instanceId
     * @returns An Observable containing the Array<ProductDefinitionInstanceStub>
     */
    ProductDefinitionInstanceService.prototype.ListProductVersionsAsync = function (instanceId) {
        return this.http.get(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/" + instanceId + "/listproductversions")
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List By Ids Async.
     * @param ids
     * @returns An Observable containing the Array<ProductDefinitionInstance>
     */
    ProductDefinitionInstanceService.prototype.ListByIdsAsync = function (ids) {
        var params = new http_1.HttpParams();
        if (ids)
            params = params.set('ids', ids.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/byids", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List By Owner Id Async.
     * @param ownerIds
     * @param completed
     * @returns An Observable containing array of ProductDefinitionInstanceStub
     */
    ProductDefinitionInstanceService.prototype.ListByOwnerIdAsync = function (ownerIds, completed) {
        var params = new http_1.HttpParams();
        if (ownerIds)
            params = params.set('ownerIds', ownerIds.toString());
        if (completed)
            params = params.set('completed', completed.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/byownerid", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List By Definition Id Async.
     * @param productDefinitionIds
     * @returns An Observable containing array of ProductDefinitionInstanceStub
     */
    ProductDefinitionInstanceService.prototype.ListByDefinitionIdAsync = function (productDefinitionIds) {
        var params = new http_1.HttpParams();
        if (productDefinitionIds)
            params = params.set('productDefinitionIds', productDefinitionIds.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/bydefinitionid", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Post.
     * @param productDefinitionId
     * @returns An Observable containing ProductDefinitionInstance
     */
    ProductDefinitionInstanceService.prototype.CreateAsync = function (productDefinitionId) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/" + productDefinitionId, null)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Post Allocation.
     * @param productInstanceId
     * @param addAllocationRequest
     * @returns An Observable containing boolean
     */
    ProductDefinitionInstanceService.prototype.PostAllocationAsync = function (productInstanceId, addAllocationRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/" + productInstanceId + "/allocations", addAllocationRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Put Allocation.
     * @param productInstanceId
     * @param allocationId
     * @param amendAllocationRequest
     * @returns An Observable containing ProductDefinitionInstance
     */
    ProductDefinitionInstanceService.prototype.PutAllocationAsync = function (productInstanceId, allocationId, amendAllocationRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/" + productInstanceId + "/allocations/" + allocationId, amendAllocationRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Delete Allocation.
     * @param productInstanceId
     * @param allocationId
     * @returns An Observable containing ProductDefinitionInstance
     */
    ProductDefinitionInstanceService.prototype.DeleteAllocationAsync = function (productInstanceId, allocationId) {
        return this.http.delete(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/" + productInstanceId + "/allocations/" + allocationId)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Upgrade Async.
     * @param upgradeInstanceRequest
     * @returns An Observable containing the ProductDefinitionInstance
     */
    ProductDefinitionInstanceService.prototype.UpgradeAsync = function (upgradeInstanceRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/upgrade", upgradeInstanceRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Save Async.
     * @param productDefinitionInstances
     * @returns An Observable containing boolean
     */
    ProductDefinitionInstanceService.prototype.SaveAsync = function (productDefinitionInstances) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/", productDefinitionInstances)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Save Tree Async.
     * @param productDefinitionInstance
     * @returns An Observable containing boolean
     */
    ProductDefinitionInstanceService.prototype.SaveTreeAsync = function (productDefinitionInstance) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/savetree", productDefinitionInstance)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * In Use Async.
     * @param id
     * @returns An Observable containing BoolResult
     */
    ProductDefinitionInstanceService.prototype.InUseAsync = function (id) {
        return this.http.get(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/" + id + "/inuse")
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Add Product Phase Async.
     * @param addProductInstancePhaseRequest
     * @returns An Observable containing the ProductPhaseInstance
     */
    ProductDefinitionInstanceService.prototype.AddProductPhaseAsync = function (addProductInstancePhaseRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/addproductphase", addProductInstancePhaseRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Amend Product Phase Async.
     * @param amendProductInstancePhaseRequest
     * @returns An Observable containing the ProductPhaseInstance
     */
    ProductDefinitionInstanceService.prototype.AmendProductPhaseAsync = function (amendProductInstancePhaseRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/amendproductphase", amendProductInstancePhaseRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Remove Product Phase Async.
     * @param removeProductInstancePhaseRequest
     * @returns An Observable containing the ProductDefinitionInstance
     */
    ProductDefinitionInstanceService.prototype.RemoveProductPhaseAsync = function (removeProductInstancePhaseRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/removeproductphase", removeProductInstancePhaseRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Add Unit Rule Async.
     * @param addUnitRuleRequest
     * @returns An Observable containing the UnitRangeRuleInstance
     */
    ProductDefinitionInstanceService.prototype.AddUnitRuleAsync = function (addUnitRuleRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/addunitrule", addUnitRuleRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Amend Unit Rule Async.
     * @param amendUnitRuleRequest
     * @returns An Observable containing the UnitRangeRuleInstance
     */
    ProductDefinitionInstanceService.prototype.AmendUnitRuleAsync = function (amendUnitRuleRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/amendunitrule", amendUnitRuleRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Remove Unit Rule Async.
     * @param removeUnitRuleRequest
     * @returns An Observable containing ProductDefinitionInstance
     */
    ProductDefinitionInstanceService.prototype.RemoveUnitRuleAsync = function (removeUnitRuleRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/removeunitrule", removeUnitRuleRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Add Date Rule Async.
     * @param addDateRuleRequest
     * @returns An Observable containing the DateRangeRuleInstance
     */
    ProductDefinitionInstanceService.prototype.AddDateRuleAsync = function (addDateRuleRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/adddaterule", addDateRuleRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Amend Date Rule Async.
     * @param amendDateRuleRequest
     * @returns An Observable containing the DateRangeRuleInstance
     */
    ProductDefinitionInstanceService.prototype.AmendDateRuleAsync = function (amendDateRuleRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/amenddaterule", amendDateRuleRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Remove Date Rule Async.
     * @param removeDateRuleRequest
     * @returns An Observable containing the ProductDefinitionInstance
     */
    ProductDefinitionInstanceService.prototype.RemoveDateRuleAsync = function (removeDateRuleRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/" + removeDateRuleRequest + "/removedaterule", removeDateRuleRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Post Outcome.
     * @param productInstanceId
     * @param addOutcomeRequest
     * @returns An Observable containing InstanceOutcome
     */
    ProductDefinitionInstanceService.prototype.PostOutcomeAsync = function (productInstanceId, addOutcomeRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/" + productInstanceId + "/outcomes", addOutcomeRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Put Outcome.
     * @param productInstanceId
     * @param outcomeId
     * @param amendOutcomeRequest
     * @returns An Observable containing InstanceOutcome
     */
    ProductDefinitionInstanceService.prototype.PutOutcomeAsync = function (productInstanceId, outcomeId, amendOutcomeRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/" + productInstanceId + "/outcomes/" + outcomeId, amendOutcomeRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Delete Outcome.
     * @param productInstanceId
     * @param outcomeId
     * @returns An Observable containing boolean
     */
    ProductDefinitionInstanceService.prototype.DeleteOutcomeAsync = function (productInstanceId, outcomeId) {
        return this.http.delete(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/" + productInstanceId + "/outcomes/" + outcomeId)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Generate Term.
     * @param generateTermRequest
     * @returns An Observable containing the Term
     */
    ProductDefinitionInstanceService.prototype.GenerateTermAsync = function (generateTermRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/productdefinitioninstance/generateterm", generateTermRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    ProductDefinitionInstanceService.ngInjectableDef = i0.defineInjectable({ factory: function ProductDefinitionInstanceService_Factory() { return new ProductDefinitionInstanceService(i0.inject(i1.HttpClient), i0.inject(i2.DELIVERABLE_CLIENT_CONFIG)); }, token: ProductDefinitionInstanceService, providedIn: "root" });
    ProductDefinitionInstanceService = __decorate([ __param(1, core_1.Inject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)),
        __metadata("design:paramtypes", [http_1.HttpClient, Object])
    ], ProductDefinitionInstanceService);
ProductDefinitionInstanceService.ɵfac = function ProductDefinitionInstanceService_Factory(t) { return new (t || ProductDefinitionInstanceService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)); };
ProductDefinitionInstanceService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ProductDefinitionInstanceService, factory: function (t) { return ProductDefinitionInstanceService.ɵfac(t); }, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProductDefinitionInstanceService, [{
        type: core_1.Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: Object, decorators: [{
                type: core_1.Inject,
                args: [deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG]
            }] }]; }, null); })();
    return ProductDefinitionInstanceService;
}());
exports.ProductDefinitionInstanceService = ProductDefinitionInstanceService;

